// Auto-import SASS generated CSS
import './index.css';

export {default as Chips, ChipsProps} from './Chips';
export {default as default} from './Chips';
